import { FC } from "react";

import ConfirmModal from "../../../components/ConfirmModal";

type Props = {
    open: boolean;
    count: number;
    loading?: boolean;
    onYes: () => void;
    onNo: () => void;
    onClose: () => void;
};

const RepeatAssignConfirm: FC<Props> = ({
    open,
    count,
    loading,
    onYes,
    onNo,
    onClose,
}) => (
    <ConfirmModal
        open={open}
        isLoading={loading}
        handleClose={onClose}
        handleCancel={onNo}
        handleConfirm={onYes}
        title="Redoublement ?"
        confirmLabel="Oui, compter"
        cancelLabel="Non, juste déplacer"
        confirmVariant="tertiary"
        cancelVariant="primary"
        description={
            count > 1
                ? `${count} apprenants changent de promotion. Compter un redoublement pour chacun d'eux ? Les personnes sans promo de ce lot ne sont pas concernées.`
                : "Cet apprenant change de promotion. S'agit-il d'un redoublement ?"
        }
    />
);

export default RepeatAssignConfirm;
